import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../../redux/pageSlice";
import "./MeetTheCows.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import IRTCBox from "../../../Component/ReuseComponent/ITCBox/IRTCBOX";
import OurValuesBox from "../../../Component/ReuseComponent/OurValuesBox/OurValuesBox";
import ImgBox from "../../../Component/ReuseComponent/ImgBox/ImgBox";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";

export default function MeetTheCowsArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    dispatch(fetchPageData({ page_id: 8, lang: "ar" }));
  }, [dispatch]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");
  const section3 = data.find((s) => s.section_id === "3");
  const section4 = data.find((s) => s.section_id === "4");

  return (
    <>
      <LoaderWrap>
        <div className="MeetTheCowsContainer">
          <section>
            <MeetTheCowsS1 section1={section1} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="MTCS2">
            <MeetTheCowsS2 section2={section2} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="MTCS3">
            <MeetTheCowsS3 contents={section2?.contents} />
          </VisibilitySection>
          <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="MTCS4">
            <MeetTheCowsS4 section3={section3} />
          </VisibilitySection>
          <VisibilitySection index={4} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="MTCS5">
            <MeetTheCowsS5 section4={section4} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function MeetTheCowsS1({ section1 }) {
  return (
    <>
      <div className="MTCS1">
        <IRTCBox Title={section1?.title} TitleWidth="" Para={section1?.description} ParaWidth="" ImgSrc={section1?.image} ImgAlt="" ImgOrder={1} />
      </div>
    </>
  );
}
function MeetTheCowsS2({ section2 }) {
  return (
    <>
      <div className="MTCS2">
        <TC3L Title={section2?.title} TitleWidth="56vw" />
      </div>
    </>
  );
}
function MeetTheCowsS3({ contents }) {
  return (
    <>
      <div className="MTCS3Ar">
        {contents?.map((item) => (
          <OurValuesBox key={item.id} Head={item.title} Title={item.description} Image={item.image} ImageAlt={item.title} Height="32vw" />
        ))}
      </div>
    </>
  );
}
function MeetTheCowsS4({ section3 }) {
  const sentences = section3?.description?.split(".").filter(Boolean) || [];

  const Para = sentences.map((s) => s.trim()).join(".<br />") + ".";
  return (
    <>
      <div className="MTCS4">
        <IRTCBox
          Title={section3?.title}
          TitleWidth=""
          Para={
            <>
              <div dangerouslySetInnerHTML={{ __html: Para }} />
            </>
          }
          ParaWidth=""
          ImgSrc={section3?.image}
          ImgAlt=""
        />
      </div>
    </>
  );
}
function MeetTheCowsS5({ section4 }) {
  return (
    <>
      <div className="MTCS5">
        <TC3L Title={section4?.title} TitleWidthMob="70vw" Para={section4?.description} ParaWidth="55vw" />
        <ImgBox ImgSrc={section4?.image} ImgAlt="" imgHeight="45vw" />
      </div>
    </>
  );
}
